import { NewEmailTemplate } from "types/emailTemplate.type";
import {
  DEFAULT_TEMPLATE,
  LANGUAGES_INPUTS,
} from "./EmailTemplateForm.constants";

export const isImage = (url: string) => {
  const cleanUrl = url.split("?")[0];
  return /\.(jpe?g|png|gif|bmp|webp|svg(\+xml)?|svgz)$/i.test(cleanUrl);
};

export const sortByLanguage = (a: string, b: string) => b.localeCompare(a);

const getTranslationContent = (
  languageCode: string,
  template: NewEmailTemplate,
): string => {
  return (
    template.translations.find(
      (translation) =>
        translation.languageCode === languageCode &&
        translation.subject === "content",
    )?.content ?? ""
  );
};

export const generateDefaultTemplate = (
  template?: NewEmailTemplate,
): NewEmailTemplate => {
  if (!template) {
    return DEFAULT_TEMPLATE;
  }

  return {
    ...template,
    translations: LANGUAGES_INPUTS.map((languageCode) => ({
      languageCode,
      subject: "content",
      content: getTranslationContent(languageCode, template),
    })),
  };
};
